import { useQuery } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';

export const useAPIGetAllSoftwares = () =>
    useQuery({
        queryKey: ['all-softwares'],

        queryFn: async () => {
            const response = await RQAPICallWithData<Record<string, string[]>>({
                endpoint: `integrations/all_softwares`,
                method: 'GET',
                skipCaseConversion: true,
            });
            return response.content.data;
        },
    });
